export default "__VITE_ASSET__13883877__"